import { render, staticRenderFns } from "./StepConfirmarConsulta.vue?vue&type=template&id=3cb936a2"
import script from "./StepConfirmarConsulta.vue?vue&type=script&lang=js"
export * from "./StepConfirmarConsulta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports